import { useNavigate } from 'react-router-dom';
import { Plus, Truck } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Button } from '@vnetwork/ui/primitives';
import { useSuppliers } from '@/api/capacities';
import { MastersListSection } from '../shared/masters-list-section';
import { supplierColumns } from './list-configs/supplier-column-definitions';

/**
 * Suppliers master list — a `PageHeader` over the server-paginated
 * `MastersListSection` (search + code/name/address/status columns). Rows link to
 * the supplier detail route. Read-only (W1 scope).
 */
export default function CapacitySuppliersPage() {
  const navigate = useNavigate();

  return (
    <Container size="full">
      <PageHeader
        title="Suppliers"
        description="Vendors that supply equipment and components to the warehouse."
        style={{ marginBottom: 'var(--vn-space-4)' }}
        actions={
          <Button startIcon={<Plus size={15} />} onClick={() => navigate('/capacities/suppliers/new')}>
            New supplier
          </Button>
        }
      />

      <MastersListSection
        useList={useSuppliers}
        columns={supplierColumns}
        getRowId={(r) => r.id}
        onRowClick={(r) => navigate(`/capacities/suppliers/${r.id}`)}
        searchPlaceholder="Search suppliers…"
        emptyIcon={<Truck size={24} />}
        emptyTitle="No suppliers found"
        errorTitle="Failed to load suppliers"
      />
    </Container>
  );
}
